<template lang="pug">
.l-logo(:style="styleObject",ref="root")
  a.l-logo__logo(
    @click="click"
  )
  transition(@enter="enter" @leave="leave")
    p.l-logo__map(v-if="store.ui.state.maptype == 1") {{store.ui.state.getMaptypeTxtByMaptype(1)}}
  transition(@enter="enter" @leave="leave")
    p.l-logo__map(v-if="store.ui.state.maptype == 2") {{store.ui.state.getMaptypeTxtByMaptype(2)}}
  transition(@enter="enter" @leave="leave")
    p.l-logo__map(v-if="store.ui.state.maptype == 3") {{store.ui.state.getMaptypeTxtByMaptype(3)}}
  transition(@enter="enter" @leave="leave")
    p.l-logo__map(v-if="store.ui.state.maptype == 4") {{store.ui.state.getMaptypeTxtByMaptype(4)}}
  transition(@enter="enter" @leave="leave")
    p.l-logo__map(v-if="store.ui.state.maptype == 5") {{store.ui.state.getMaptypeTxtByMaptype(5)}}
    
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-logo
  pos(0,0,10)
  background-color #FFF
  transition height 500ms $easeInQuad
  +pc()
    width 90px
  +sp()
    width 108px
  &:after
    content ""
    border 1px solid #e5e5e5
    +pc()
      width calc(100% - 20px)
      height calc(100% - 20px)
      pos(10px,10px)
    +sp()
      width calc(100% - 20px)
      height calc(100% - 20px)
      pos(10px,10px)

  &__logo
    display block
    background-size cover
    background-image url('~@/assets/images/ui-nav-logo.png')
    cursor pointer
    no_highlight()
    $w = 161px
    $h = 187px
    +pc()
      $r = 0.32
      wh($w*$r,$h*$r)
      pos(20px,20px,2)
    +sp()
      $r = 0.45
      wh($w*$r,$h*$r)
      pos(20px,20px,2)
  
  &__map
    font_notoserif_semibold()
    display flex
    writing-mode vertical-rl
    align-items center
    text-align center
    width 100%
    letter-spacing 0.1rem
    position absolute
    z-index 2
    white-space nowrap
    +pc()
      font-size 16px
      top 90px
    +sp()
      font-size 24px
      top 115px

</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent, computed, reactive ,watch ,onMounted,ref } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'


export default defineComponent({
  name:'Logo',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const state = reactive({
      mapHeight:200
    })
    const root = ref(null)
    
    const click = ()=> {
      if(store.ui.state.introMotion != 0) return
      store.ui.state.maptype = 1
      store.ui.state.hotoke = false
      router.push('/')
    }
    const styleObject = computed(()=>{
      const offset = store.browser.state.responsive == 'pc' ? 115 : 140
      return {
        height : (offset + state.mapHeight) + 'px'
      }
    })

    const enter = (el, done)=> {
      state.mapHeight = $(el).height()
      $(el).css({opacity:0})
      gsap.to(
        el,
        {opacity:1,duration:1.0,delay:1,onComplete:()=>{
          done()
        }}
      )
    }
    const leave = (el, done)=> {
      gsap.to(
        el,
        {opacity:0,duration:0.5,delay:0,onComplete:()=>{
          done()
        }}
      )
    }

    onMounted(()=>{
      state.mapHeight = $(root.value).find('.l-logo__map').height()
    })

    return{
      root,
      styleObject,
      click,
      store,
      enter,
      leave
    }
  }
})
</script>
